<template>
  <section
    class="img-holder"
    :style="{ 'background-image': `url(${thumb})` }"
  ></section>
</template>

<script>
export default {
  props: ['product'],
  computed: {
    thumb() {
      if (this.product.isCustomizable) {
        return this.product.previewImage
      } else {
        return `/media/print-store/${this.product.printStoreId}/preview/${this.product.previewImage}/68`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.img-holder {
  width: 34px;
  height: 34px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  flex-shrink: 0;
  flex-grow: 0;
}
</style>
